import { createLogger } from '@aviv-unified-frontend/runtime/monitoring';
import { MFE_IDENTIFIER } from '@price-pages-agency-cards/src/constants';
export const logger = createLogger(MFE_IDENTIFIER);
